var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"main not-found"},[_vm._m(0),_c('div',[_c('button',{staticClass:"btn btn-secondary",on:{"click":_vm.onButtonClick}},[_vm._v(" Przejdź "+_vm._s(_vm.token ? 'do pulpitu' : 'do strony logowania')+" ")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"not-found__descWrapper"},[_c('h3',{staticClass:"h3 not-found__desc text-center"},[_vm._v(" Trwa pobieranie pliku... ")])])
}]

export { render, staticRenderFns }